import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDashed, faPlus } from '@fortawesome/pro-light-svg-icons';

import UserIconList from 'components/user_icon_list';

interface Props {
  assignee?: object;
  onClick?: (event: React.MouseEvent) => void;
}

export default function Assignee({ assignee, onClick }: Props) {
  return (
    <div
      style={{ marginLeft: assignee ? 0 : -3 }}
      onClick={assignee ? undefined : onClick}
    >
      {assignee
        ? <UserIconList size="30px" users={[assignee]} />
        : (
          <span className="apex-tasks-list__assignee-placeholder clickable fa-stack">
            <FontAwesomeIcon className="fa-stack-2x text-muted" icon={faCircleDashed} />
            <FontAwesomeIcon className="fa-stack-1x" icon={faPlus} />
          </span>
        )}
    </div>
  );
}
